import React from 'react';
import styled from 'styled-components';

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h1`
  font-size: 1.35rem;
  font-weight: 700;
  color: ${({ theme }) => theme.less.textColor};
`;

const Value = styled.td`
  font-size: 1.25rem;
  font-weight: 600;
  color: ${({ theme }) => theme.less.primaryColor};
  padding: 5px 0;
  padding-inline-end: 15px;
  width: 0%;
  vertical-align: middle;
`;

const Icon = styled.img`
  width: 38px;
`;

const Description = styled.td`
  position: relative;
  font-size: 1rem;
  color: ${({ theme }) => theme.less.textColor};
  opacity: 0.75;
  vertical-align: middle;

  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  text-align: left;
  line-height: 2.15;
  padding-left: 10px;
`;

const Bar = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  height: 70%;
  background-color: ${({ theme }) => theme.less.primaryColor};
  opacity: 0.25;
  border-radius: 8px;
  z-index: -1;
`;

const getIcon = (value, icons) => {
  if (icons === 'browsers') {
    switch (value) {
      case 'iOS Safari':
        return 'safari-mobile';
      case 'Safari':
        return 'safari';
      case 'Google Chrome':
        return 'chrome';
      case 'Chrome Mobile':
        return 'chrome-mobile';
      case 'Chrome for Android':
        return 'chrome-mobile';
      case 'Google Search Mobile':
        return 'chrome-mobile';
      case 'Firefox':
        return 'firefox';
      case 'Samsung Internet':
        return 'samsung';
      case 'Microsoft Edge':
        return 'edge';
      case 'Opera':
        return 'opera';
      case 'Opera Mini':
        return 'opera-mobile';
      case 'Opera Mobile':
        return 'opera-mobile';
      case 'Opera GX':
        return 'opera';
      case 'BlackBerry Mobile':
        return 'blackberry';
      default:
        return 'unknown';
    }
  } else {
    return value;
  }
};

const Stats = ({ data, percentage = true, max = 10, icons }) => (
  <Column>
    <Title>{data.label}</Title>
    <table>
      <tbody>
        {data.items.slice(0, max).map((item) => (
          <tr key={item.value} title={item.value}>
            <Value>
              {/* eslint-disable-next-line max-len */}
              <Icon src={`${process.env.PUBLIC_URL}/${icons}/${getIcon(item.value, icons)}.svg`} />
            </Value>
            <Description>
              <Bar style={{
                width:
                `${Math.round(
                  (item.pageviews / data.pageviews.sum) * 100
                )}%` }}
              />
              {
                percentage
                ? `${Math.round(
                    (item.pageviews / data.pageviews.sum) * 100
                  )}%`
                : item.pageviews
              }
            </Description>
          </tr>
        ))}
      </tbody>
    </table>
  </Column>
);

export default Stats;
